var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('certificate-data-view',{staticClass:"my-3",attrs:{"college-id":_vm.$store.state.userInfo.userId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }